import React from "react";
import { connect } from "react-redux";
import { loadSubMenu } from "../actions";

import MainSeguimientoPlanMovilidad from "./main";
import MedidasPlanMovilidad from "./medidas";
import FinalizarSeguimientoPlanMovilidad from "./finalizar";
import RoadMapSeguimientoPlanMovilidad from "./roadmap";

class SeguimientoPlanMovilidad extends React.PureComponent {
  constructor(props) {
    super(props);
    this.loadSubMenu();
  }

loadSubMenu = () => {
  const tabs = [
    { text: "Main", contentId: 0 },
    { text: "Medidas", contentId: 1 },
    { text: "Roadmap", contentId: 2 },
    { text: "Finalizar", contentId: 3 },

  ];
  this.props.dispatch(loadSubMenu(tabs, tabs.length ? tabs[0].contentId : null));
}

renderBody = () => {
  switch (this.props.subMenuPosition) {
    case 0: {
      return (<MainSeguimientoPlanMovilidad />);
    }
    case 1: {
      return (<MedidasPlanMovilidad />);
    }
    case 2: {
      return (<RoadMapSeguimientoPlanMovilidad />);
    }
    case 3: {
      return (<FinalizarSeguimientoPlanMovilidad />);
    }
    default:
      return <div />;
  }
}

render() {
  return (
    <React.Fragment>
      {this.renderBody()}
    </React.Fragment>
  );
}
}

const mapStateToProps = (state) => ({
  planMovilidad: state.planMovilidad,
  subMenuPosition: state.planMovilidad.subMenuPosition,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(SeguimientoPlanMovilidad);
